import React, { Component } from 'react';
import css from '../ProjectPage/ProjectPage.module.scss';
import Header from '../ProjectPage/Header';
import ProjectItem from '../ProjectItem.js';

import ImgS1 from './assets/s1.jpg';
import ImgS2 from './assets/s2.png';
import ImgS3 from './assets/s3.png';
import ImgS4 from './assets/s4.jpg';
import ImgS5 from './assets/s5.jpg';
import ImgS6 from './assets/s6.jpg';
import ImgS7 from './assets/s7.jpg';
import ImgS8 from './assets/s8.jpg';
import ImgS9 from './assets/s9.jpg';
import ImgS10 from './assets/s10.jpg';
import ImgAskdarcel from '../assets/AskDarcel.png';
import ImgYNABMobile from '../assets/YNABMobile.jpg';

export default class Sheltertech extends Component {

  render () {
      return (
        <div className={css.projectPage}>
          <Header
            title='ShelterTech'
            year='2016 — Present'
            position='Co-Founder & Executive Board Member'
          />
          <div className={css.content}>
            <img src={ImgS1} alt='ShelterTech' />
            <div className={css.text}>
              <p>ShelterTech is an award winning non-profit solving the biggest technology challenges faced by people experiencing homelessness. Founded in 2016, ShelterTech is now a 100 member strong volunteer-only organisation with over $100,000 in annual funding, $800,000 in in-kind contributions, and 3 program offerings.</p>
            </div>
            <img src={ImgS2} alt='ShelterTech Identity' />
            <img src={ImgS3} alt='Program Logos' />
            <div className={css.text}><p>ShelterTech combines the innovation of the tech community and the knowledge of those who’ve experienced homelessness to build a suite of products that addresses the Digital Divide. ShelterConnect installs and operates free wifi for over 3000 people in need, AskDarcel is the first official online directory of human services in the city of San Francisco, and Casey is automating case management and referrals.</p></div>
            <img src={ImgS4} alt='ShelterTech Event' />
            <div className={css.text}>
              <p>At ShelterTech I’ve put time into every facet of the organisation—from researching and writing about housing issues to designing and developing products for underserved communities, from recruiting and onboarding new talent to hosting panels of industry leaders.</p>
              <p>My main role is the product manager of AskDarcel, ShelterTech’s primary digital product. I manage the nearly 40 people working on the project, determine the project’s roadmap, and communicate with internal teams, our grant provider, and other external stakeholders.</p>
              <p>I also serve as head of our design team where my responsibilities include recruiting and onboarding new talent, managing design projects and user research, and creating visual assets for AskDarcel and ShelterTech. </p>
            </div>
            <img src={ImgS5} alt='ShelterTech Website' />
            <img src={ImgS6} alt='ShelterTech Components' />
            <img src={ImgS7} alt='ShelterTech Editorial Infographics' />
            <div className={css.text}>
              <p>Our startup roots taught us to make the most impact with the least capital. We adopted a crowd-sourced community development organisational model so we could design and develop world-class tech products without hiring a single developer or designer.</p>
              <p>Every volunteer delivers maximum value by volunteering their professional skill set: developers develop, designers design, sales people evangelise. Money is reserved for operational expenses and to hire people with lived experience of homelessness to advise our product teams and directly improve product.</p>
            </div>
            <img src={ImgS8} alt='ShelterTech Business Cards' />
            <img src={ImgS9} alt='ShelterTech Year in Review' />
            <div className={css.text}>
              <p>As a distributed team, I take organisation, tooling, and communication seriously. I’m an evangelist for adopting the latest technologies that help our team operate more efficiently with as little effort spent on onboarding and communication as possible.</p>
              <p>From the data we’ve collected about volunteering, it’s essential that the startup time for onboarding is minimal because people’s lives inevitably get busy and volunteers are most productive in the first few weeks of interest. So, I’ve made it my personal goal that any volunteer that wants to help the homeless can join our organisation and get right into a project within a day.</p>
              <p>We use Slack and Quip for internal communications and project management, Zoom for meetings, Figma for sharing our design system and projects, and Github and Zenhub for managing the codebase. </p>
            </div>
            <img src={ImgS10} alt='Hosting a panel at Code for America' />
            <div className={css.text}>
              <p>Want to know more about the design process for this project? <a href="https://docs.google.com/presentation/d/e/2PACX-1vQpY20_e2nBLjCI2KKY2TvxfFZw1UEDK4eoNmJYOhSL4rLSRDyk4X6QX_6vQq7HHQywwD_mcYiJrmsH/pub?start=false&loop=false&delayms=10000" target="_blank" rel="noopener noreferrer">View the case study here.</a></p>
            </div>
          </div>
          <div className={css.moreWork}>
            <header>More Projects</header>
              <ul className={css.moreWorkList}>
                <ProjectItem
                  title='AskDarcel'
                  description='Housing and human services directory'
                  position='Product Manager / Product Designer'
                  img={ImgAskdarcel}
                  link='Askdarcel'
                />
                <ProjectItem
                  title='YNAB Mobile Redesign'
                  description='A spec redesign of the YNAB app'
                  exploration='Spec Redesign'
                  img={ImgYNABMobile}
                  link='YNABMobile'
                />
              </ul>
          </div>
        </div>
      )
   }
}
